// Thought of the day. Rotates daily by day-of-year. Mix of Setswana proverbs,
// business wisdom, and brand-friendly one-liners. Curated short — fits one
// line on mobile without truncation.

export interface Quote {
  text: string;
  attribution?: string;
  // Optional translation for non-English quotes (shown smaller below).
  gloss?: string;
}

export const QUOTES: Quote[] = [
  { text: 'Mmualebe o a bo a sena seriti.', attribution: 'Setswana proverb', gloss: 'A talker has no dignity.' },
  { text: 'Mmangwana o tshwara thipa ka fa bogaleng.', attribution: 'Setswana proverb', gloss: "A mother holds the knife on the sharp side — she protects her children." },
  { text: 'Sediba ga se itsewe ke yo o sa nweng.', attribution: 'Setswana proverb', gloss: "One who doesn't drink doesn't know the well." },
  { text: 'Lerumo le bothata mo serameng.', attribution: 'Setswana proverb', gloss: 'A spear is hard to hold in the cold — start tasks while you are still motivated.' },
  { text: "Mabogo dinku a a thebana.", attribution: 'Setswana proverb', gloss: 'Hands wash each other.' },
  { text: 'The best way to predict the future is to invent it.', attribution: 'Alan Kay' },
  { text: 'Slow is smooth. Smooth is fast.', attribution: 'Navy SEAL adage' },
  { text: 'It always seems impossible until it is done.', attribution: 'Nelson Mandela' },
  { text: 'Insurance is not for when things go right.', attribution: 'AD culture' },
  { text: "If you can't measure it, you can't improve it.", attribution: 'Peter Drucker' },
  { text: 'Done is better than perfect.', attribution: 'Sheryl Sandberg' },
  { text: 'A goal without a plan is just a wish.', attribution: 'Antoine de Saint-Exupéry' },
  { text: 'The work will teach you how to do it.', attribution: 'Estonian proverb' },
  { text: 'Be kind, for everyone you meet is fighting a hard battle.', attribution: 'Plato' },
  { text: 'Strive not to be a success, but rather to be of value.', attribution: 'Einstein' },
];

const dayOfYear = (d: Date): number => {
  const start = new Date(d.getFullYear(), 0, 0);
  return Math.floor((d.getTime() - start.getTime()) / 86400000);
};

export const quoteOfTheDay = (date: Date = new Date()): Quote => {
  // QUOTES is non-empty (compile-time constant) — the index is always valid.
  return QUOTES[dayOfYear(date) % QUOTES.length] ?? QUOTES[0]!;
};
